import { render } from "./ViewMore.vue?vue&type=template&id=27e4d8d0&scoped=true"
import script from "./ViewMore.vue?vue&type=script&lang=js"
export * from "./ViewMore.vue?vue&type=script&lang=js"

import "./ViewMore.vue?vue&type=style&index=0&id=27e4d8d0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e4d8d0"]])

export default __exports__